/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class CustomerAttachmentDTO extends JSONable {
  uuid: string | undefined = undefined ;
  customerUuid: string | undefined = undefined;
  fileName: string | undefined = undefined;
  fileStoreAttachmentUuid: string | undefined = undefined;
  fileSizeKB: number | undefined = undefined;
  fileType: string | undefined = undefined;
  description: string | undefined = undefined;
}
